import React from 'react';

const Legacy = () => {
  return (
    <section id="legacy" className="section legacy-section">
      <div className="container">
        <div className="legacy-content">
          <h2 className="legacy-title">Enduring Legacy</h2>
          <p className="legacy-text">
            For more than a century, Prince Edward School Rugby has played a defining role in Zimbabwean schools rugby — producing players, leaders, and custodians of the game, while upholding traditions of excellence, resilience, and pride.
          </p>
          <div className="legacy-values">
            <div className="value-item">
              <h4>Excellence</h4>
              <p>Consistent high standards on and off the field</p>
            </div>
            <div className="value-item">
              <h4>Resilience</h4>
              <p>Overcoming challenges with determination</p>
            </div>
            <div className="value-item">
              <h4>Pride</h4>
              <p>Honoring the Tigers tradition</p>
            </div>
            <div className="value-item">
              <h4>Character</h4>
              <p>Building leaders through rugby</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Legacy;

